export default __webpack_public_path__ + "static/media/discord.bb116754.svg";